(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bercail-page-title"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.page-title-subtitle-toggle');
    if (!toggle) return;

    var wrapper = toggle.closest('.page-title-subtitle');
    if (!wrapper) return;

    var preview = wrapper.querySelector('.page-title-subtitle-preview');
    var full = wrapper.querySelector('.page-title-subtitle-full');
    if (!preview || !full) return;

    var isExpanding = full.hasAttribute('hidden');

    if (isExpanding) {
      full.removeAttribute('hidden');
      preview.setAttribute('hidden', '');
    } else {
      preview.removeAttribute('hidden');
      full.setAttribute('hidden', '');
    }

    toggle.setAttribute('aria-expanded', isExpanding);
    toggle.textContent = isExpanding
      ? toggle.getAttribute('data-label-less')
      : toggle.getAttribute('data-label-more');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.popular-collections-subtitle-toggle');
    if (!toggle) return;

    var wrapper = toggle.closest('.popular-collections-subtitle-wrapper');
    if (!wrapper) return;

    var preview = wrapper.querySelector('.popular-collections-subtitle-preview');
    var full = wrapper.querySelector('.popular-collections-subtitle-full');
    if (!preview || !full) return;

    var isExpanding = full.hasAttribute('hidden');

    if (isExpanding) {
      full.removeAttribute('hidden');
      preview.setAttribute('hidden', '');
    } else {
      preview.removeAttribute('hidden');
      full.setAttribute('hidden', '');
    }

    toggle.setAttribute('aria-expanded', isExpanding);
    toggle.textContent = isExpanding
      ? toggle.getAttribute('data-label-less')
      : toggle.getAttribute('data-label-more');
  });

  } catch(e) { console.error(e); }
})();
})();
